document.addEventListener('DOMContentLoaded', function () {
  function normalize(str) {
    return (str || '').toLowerCase().trim();
  }

  function filterGallery(colorValue) {
    if (!colorValue) return;
    const color = normalize(colorValue);
    console.log('[gallery-filter] filtering for color:', color);

    let matched = 0;
    document.querySelectorAll('[id^="Slide-"], .product-media-container, .product__media-item').forEach(function (slide) {
      const img = slide.querySelector('img');
      if (!img) return;
      const alt = normalize(img.getAttribute('alt'));
      const show = alt.includes(color);
      slide.style.display = show ? '' : 'none';
      if (show) matched++;
    });

    document.querySelectorAll('.thumbnail-list__item').forEach(function (thumb) {
      const img = thumb.querySelector('img');
      if (!img) return;
      const alt = normalize(img.getAttribute('alt'));
      thumb.style.display = alt.includes(color) ? '' : 'none';
    });

    console.log('[gallery-filter] matched images:', matched);
  }

  function getSelectedColor() {
    const checkedRadio = document.querySelector('input[type="radio"][name*="Color" i]:checked, input[type="radio"][name*="color" i]:checked');
    if (checkedRadio) return checkedRadio.value;

    const selectEl = document.querySelector('select[name*="Color" i]');
    if (selectEl) return selectEl.value;

    const activeSwatch = document.querySelector('[aria-checked="true"][data-value], .swatch-input__input:checked');
    if (activeSwatch) return activeSwatch.value || activeSwatch.getAttribute('data-value');

    return null;
  }

  // Listen for any change/click on the whole page, then re-check selected color
  document.body.addEventListener('change', function () {
    const color = getSelectedColor();
    if (color) filterGallery(color);
  });

  document.body.addEventListener('click', function (e) {
    const swatchLabel = e.target.closest('label, button, .swatch-input__label, [data-value]');
    if (swatchLabel) {
      setTimeout(function () {
        const color = getSelectedColor();
        if (color) filterGallery(color);
      }, 50);
    }
  });

  // Run once on load
  const initialColor = getSelectedColor();
  if (initialColor) filterGallery(initialColor);
});